import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'react-icons-kit';
import { androidArrowBack } from 'react-icons-kit/ionicons/androidArrowBack';

import API from "../../ApiConfig";
import { UPDATE_USER_ROLE } from '../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import { logout, updateUser } from '../../Utils/Redux/UserSlice';
const UserRoletypeSelection = ({isOpen}) => {
    const [isVisible, setIsVisible] = useState();
      const [transition, setTransition] = useState({ opacity: '0'});
      const [selectedRoleName, setSelectedRoleName]=useState("")
      const User=useSelector(state=>state.User)

      const [enterUseremail, setUserEmail]=useState(false)
      const[email, setEmail]=useState("")
      const [emailError, setEmailError] = useState("")
      const dispatch=useDispatch()
      const handleSelectRoleType=(e, roleType)=>{

        e.preventDefault()

        if(roleType=="Admin"){
          if(User.user_type=="Issuer"){
            setSelectedRoleName("ADMIN_ISSUER")
          }
          else if(User.user_type=="Verifier"){
            setSelectedRoleName("ADMIN_VERIFIER")
          }
        }
        else if(roleType=="MEMBER"){
          if(User.user_type=="Issuer"){
            setSelectedRoleName("MEMBER_ISSUER")
          }
          else if(User.user_type=="Verifier"){
            setSelectedRoleName("MEMBER_VERIFIER")
          }
        }
        setUserEmail(true)
      }
      const validateEmail = (value) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        if (!value) {
          return "Email is required";
        } else if (!pattern.test(value)) {
          return "Enter a valid email address";
        }
        return "";
      }
      const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError("");
      }

      const UpdateUserRole=(e)=>{
        e.preventDefault()
        if(User.email!==""){
        let apiData={
          user_id:User.user_id,
          email:User.email,
          role_name:selectedRoleName
        }
        API.post(UPDATE_USER_ROLE, apiData)
        .then(res=>{

          
          cogoToast.success(res.data.message)
          dispatch(updateUser({
            user_role_name:res.data.data.new_role
          }))
          setEmailError("")

        })
        .catch(err=>{
          setEmailError(err.response.data.message);
          
        })
      }
      else{
        setEmailError("Enter Email")
      }
      }
      useEffect(() => {
        let timeoutId;
    
        if (isOpen) {
          setIsVisible(true);
          timeoutId = setTimeout(() => {
            setTransition({ opacity: '1' });
          }, 10);
        } else {
          setTransition({ opacity: '0' });
          timeoutId = setTimeout(() => {
            setIsVisible(false);
          }, 800);
        }
        return () => clearTimeout(timeoutId);
      }, [isOpen]);
      
      if(isVisible){
  return (
          <div data-testid="loader" className='transition userRole-container' style={transition}>
            <body className="bg-gray-100 flex items-center justify-center min-h-screen">
  
  <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 transform transition-all">
    {enterUseremail?<div className="space-y-1">
          <label className="block font-medium mb-10"><div className='cursor-pointer mb-10' style={{display:"flex", alignItems:"center"}}><span onClick={()=>{setUserEmail(false);setEmailError("")}}><Icon icon={androidArrowBack} size={18}/></span><span style={{marginLeft:"10px"}}>Email</span></div></label>
          <input
            type="email"
            placeholder="Enter client email"
            className="mb-10 input"
            value={User.email}
            disabled
            // onChange={(e)=>handleEmailChange(e)}
          />

{emailError && (
  <p className="text-red-500 text-sm mb-4">{emailError}</p>
)}


<div className="text-center">
          <button className='btn btn-primary' onClick={(e)=>UpdateUserRole(e)}> Submit</button>

</div>
        </div>:
    <>
    <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">Welcome! Select Your Role</h2>
    <p className="text-gray-600 mb-8 text-center fontSize-16x">
      This determines your access level and how you manage your team.
    </p>

    <div className="space-y-4">
      {/* <!-- Admin Button --> */}
      <button
        className={`w-full text-left p-2 border border-gray-200 bg-white rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-md cursor-pointer ${selectedRoleName=="ADMIN_ISSUER" || selectedRoleName=="ADMIN_VERIFIER"?'bg-blue-100 text-white' : ''}`}
      onClick={(e)=>handleSelectRoleType(e, "Admin")}
      >
        <div className="flex items-center">
          <span className="text-2xl mr-4 text-blue-600">👤</span>
          <div>
            <h3 className="font-semibold text-lg text-blue-700">Admin</h3>
            <p className="text-sm text-gray-600">
              Full access to settings, user management, and configuration.
            </p>
          </div>
        </div>
      </button>

      {/* <!-- Team Member Button --> */}
      <button
        className={`w-full text-left p-2 border border-gray-200 bg-white rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-md cursor-pointer ${selectedRoleName=="MEMBER_ISSUER"|| selectedRoleName=="MEMBER_VERIFIER"?'bg-blue-100 text-white':''}`}
      
      onClick={(e)=>handleSelectRoleType(e, "MEMBER")}
      >
        <div className="flex items-center">
          <span className="text-2xl mr-4 text-gray-500">👥</span>
          <div>
            <h3 className="font-semibold text-lg text-gray-800">Team Member</h3>
            <p className="text-sm text-gray-500">
              Access to daily operations and standard features.
            </p>
          </div>
        </div>
      </button>
    </div>

    {/* <!-- Error / Message Placeholder --> */}
    <div
      id="error-message"
      className="mt-6 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg hidden text-sm text-center"
    >
      {/* <!-- Message placeholder (optional) --> */}
    </div>

    </>}
  </div>
</body>
          </div>
        );
      }
      else{
        return null
      }
}

export default UserRoletypeSelection